/**
 * Serialize a JSON-LD payload for embedding in a `<script>` element.
 *
 * WHY HTML ESCAPING IS THE WRONG TOOL HERE, and the reason this is its own tested
 * function rather than an inline `.replace()`:
 *
 * Inside a `<script>` element the HTML parser is in **script data** state, where
 * character references are NOT decoded. Escaping `<` to `&lt;` would therefore
 * leave the literal five characters in the JSON and corrupt the document — the
 * opposite of safety. It is also why React's normal text child cannot be used
 * (`<script>{json}</script>` HTML-escapes the text), which is what forces
 * `dangerouslySetInnerHTML` at the call site.
 *
 * What can actually break out of the element is the byte sequence `</script`, and
 * `<!--` / `<script` shift the parser into script-data-escaped state where a later
 * `</script>` stops closing it. Every one of those starts with `<`, so escaping
 * that single character to its JSON form `<` closes all of them at once.
 * `JSON.parse` decodes `<` back to `<`, so the payload a consumer reads is
 * byte-for-byte the object that went in.
 *
 * U+2028/U+2029 are deliberately NOT escaped: they are legal inside a JSON string
 * and this payload is parsed as `application/ld+json`, never evaluated as
 * JavaScript, which is the only context where they ever mattered.
 *
 * ⚠️ The hymnal corpus currently contains no `<` at all, so in production this
 * escape never fires. That is exactly why the test exists — an unexercised
 * mitigation is one nobody notices breaking.
 */
export function serializeJsonLd(schema: Record<string, unknown>): string {
  return JSON.stringify(schema).replace(/</g, '\\u003c')
}
